import DateFnsUtils from '@date-io/date-fns';
import {Trans} from '@lingui/macro';
import {
  Button,
  Grid,
  Paper,
  CircularProgress,
  Box,
  TextField,
} from '@material-ui/core';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import PieChartPending from 'components/Graphics/Components/PieChart';
import {useUtilInformation} from 'components/hooks';
import {i18n2} from 'features/i18n/i18n';
import {Field, Form, Formik} from 'formik';
import {KeyboardDatePicker} from 'formik-material-ui-pickers';
import React, {useEffect, useState} from 'react';
import AutocompleteMultiple from './form/multipleSelect';
import KPIGrid from './grids/KPIGrid';
import getGraphicsCollab from './requests/collabConsult/getGraphicsCollab';
import getAllSectors from './requests/getAllSectors';
import getCollabsFilteredBySectors from './requests/getCollabsFilteredBySectors';
import getCourseTypes from './requests/getCourseTypes';
import getAllShifts from './requests/getAllShifts';
import {addFilter} from './helpers/createFilters';
import moment from 'moment';
import {ReportTypes} from 'helpers/report';
import PopupReport from 'components/Popups/PopupReport';
import {UserReport} from 'constants/url';
import MultipleSelectAll from './form/multipleSelectAll';

const ConsultForm = (props) => {
  const [isConsultReady, setIsConsultReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [typeCourse, setTypeCourse] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [collabs, setCollabs] = useState([]);
  const {token} = useUtilInformation();
  const [selectedSectors, setSelectedSectors] = useState([]);
  const [dataGraphics, setDataGraphics] = useState([]);
  const [filters, setFilters] = useState([]);
  const [dateError, setDateError] = useState(null);
  const [openReport, setOpenReport] = useState(false);
  const [reportType, setReportType] = useState(null);
  const [values, setValues] = useState(null);

  useEffect(() => {
    getCourseTypes(token).then((data) => {
      if (data != null) {
        setTypeCourse(data);
      }
    });

    getAllSectors(token).then((data) => {
      if (data != null) {
        setSectors(data);
      }
    });

    getAllShifts(token).then((data) => {
      if (data != null) {
        setShifts(data);
      }
    });
  }, [token]);

  useEffect(() => {
    getCollabsFilteredBySectors(token, selectedSectors).then((data) => {
      if (data != null) {
        setCollabs(data);
      }
    });
  }, [selectedSectors, token]);

  const validateForm = (values) => {
    const errors = {};
    if (values.collaborators.length === 0) {
      errors.collaborators = 'Ingrese un colaborador';
    }
    if (values.startDate && values.endDate) {
      let start = moment(values.startDate);
      let end = moment(values.endDate);
      if (start.isAfter(end)) {
        setDateError('La fecha de inicio no puede ser mayor a la de fin');
        errors.startDate = 'La fecha de inicio no puede ser mayor a la de fin';
      } else {
        setDateError(null);
      }
    }
    return errors;
  };

  const handleSubmit = (values, formikBag, isPopup) => {
    var temporalFilters = [];
    Object.entries(values).map(([k, v]) => addFilter(k, v, temporalFilters));
    setFilters(temporalFilters);
    if (isPopup) {
      setOpenReport(true);
      setValues(values);
    } else {
      setIsLoading(true);
      formikBag.setSubmitting(false);
      getGraphicsCollab(token, values).then((data) => {
        if (data != null) {
          setIsConsultReady(true);
          setDataGraphics(JSON.parse(data));
          setIsLoading(false);
        }
      });
    }
  };

  return (
    <>
      <Paper style={{margin: 10, marginTop: 0, padding: 10}}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Formik
            initialValues={{
              sectors: '',
              collaborators: [],
              shifts: '',
              startDate: null,
              endDate: null,
              type: '',
              condition: '',
              doc_Number: '',
            }}
            enableReinitialize
            onSubmit={(values, formikBag) => {
              handleSubmit(values, formikBag, false);
            }}
            validate={validateForm}>
            {({errors, touched, ...formikProps}) => {
              return (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item md={4} xs={6}>
                      <MultipleSelectAll
                        name="sectors"
                        label={i18n2._('Sectores')}
                        changeValue={(val) => {
                          formikProps.setFieldValue('sectors', val);
                          setSelectedSectors(val);
                        }}
                        options={sectors}
                        customOptionLabel={(x) => `${x.name}`}
                        customOptionSelected={(option, value) => {
                          return option.iD_Sector === value.iD_Sector;
                        }}
                      />
                    </Grid>
                    <Grid item md={4} xs={6}>
                      <MultipleSelectAll
                        name="collaborators"
                        label={i18n2._('Colaboradores')}
                        changeValue={(val) =>
                          formikProps.setFieldValue('collaborators', val)
                        }
                        options={collabs}
                        customOptionLabel={(x) =>
                          `${x.name} ${x.cwid && '- ' + x.cwid}`
                        }
                        customOptionSelected={(option, value) => {
                          return option.employee_Nr === value.employee_Nr;
                        }}
                      />
                      {errors.collaborators && touched.collaborators ? (
                        <div style={{color: 'red'}}>{errors.collaborators}</div>
                      ) : null}
                    </Grid>
                    <Grid item md={4} xs={6}>
                      <MultipleSelectAll
                        name="shifts"
                        label={i18n2._('Turno')}
                        changeValue={(val) =>
                          formikProps.setFieldValue('shifts', val)
                        }
                        options={shifts}
                        customOptionLabel={(x) => `${x.name}`}
                        customOptionSelected={(option, value) => {
                          return option.iD_Shift === value.iD_Shift;
                        }}
                      />
                    </Grid>
                    <Grid item md={4} xs={6}>
                      <Field
                        name="startDate"
                        component={KeyboardDatePicker}
                        label={i18n2._('Fecha inicio')}
                        fullWidth
                        inputVariant="outlined"
                        variant="inline"
                        views={['year', 'month', 'date']}
                        format="dd/MM/yyyy"
                      />
                      {dateError ? (
                        <div style={{color: 'red'}}>{dateError}</div>
                      ) : null}
                    </Grid>
                    <Grid item md={4} xs={6}>
                      <Field
                        name="endDate"
                        component={KeyboardDatePicker}
                        label={i18n2._('Fecha fin')}
                        fullWidth
                        inputVariant="outlined"
                        variant="inline"
                        views={['year', 'month', 'date']}
                        format="dd/MM/yyyy"
                      />
                    </Grid>
                    <Grid item md={4} xs={6}>
                      <MultipleSelectAll
                        name="type"
                        label={i18n2._('Tipo')}
                        changeValue={(val) =>
                          formikProps.setFieldValue('type', val)
                        }
                        options={typeCourse}
                        customOptionLabel={(x) => `${x.name}`}
                        customOptionSelected={(option, value) => {
                          return option.iD_Type === value.iD_Type;
                        }}
                      />
                    </Grid>
                    <Grid item md={4} xs={6}>
                      <AutocompleteMultiple
                        name="condition"
                        label={i18n2._('Condicion')}
                        changeValue={(val) =>
                          formikProps.setFieldValue('condition', val)
                        }
                        options={[
                          {title: 'Pendientes', id: 0},
                          {title: 'Completos', id: 1},
                        ]}
                      />
                    </Grid>
                    <Grid item md={4} xs={6}>
                      <TextField
                        label={i18n2._('Documento')}
                        value={formikProps.values.doc_Number}
                        onChange={(e) =>
                          formikProps.setFieldValue(
                            'doc_Number',
                            e.target.value,
                          )
                        }
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <Button
                        type="submit"
                        disabled={formikProps.isSubmitting}
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}>
                        <Trans>Visualizar</Trans>
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}
                        onClick={(e) =>
                          formikProps.validateForm().then((errors) => {
                            if (
                              Object.keys(errors).length === 0 &&
                              errors.constructor === Object
                            ) {
                              handleSubmit(
                                formikProps.values,
                                formikProps.formikBag,
                                true,
                              );
                              setReportType(ReportTypes.PDF);
                            }
                          })
                        }>
                        <Trans>Descargar PDF</Trans>
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}
                        onClick={(e) =>
                          formikProps.validateForm().then((errors) => {
                            if (
                              Object.keys(errors).length === 0 &&
                              errors.constructor === Object
                            ) {
                              handleSubmit(
                                formikProps.values,
                                formikProps.formikBag,
                                true,
                              );
                              setReportType(ReportTypes.Excel);
                            }
                          })
                        }>
                        <Trans>Descargar excel</Trans>
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </MuiPickersUtilsProvider>
        <PopupReport
          open={openReport}
          setOpen={setOpenReport}
          name="Reporte por usuario"
          url={UserReport}
          pdfOnly={false}
          type={reportType}
          userFilters={values}
          filters={filters}
        />
      </Paper>
      {isLoading ? (
        <Grid
          container
          alignContent="center"
          alignItems="center"
          justify="center">
          <Box style={{margin: 50, padding: 50}}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : isConsultReady ? (
        <>
          <Grid
            container
            spacing={2}
            alignContent="center"
            alignItems="center"
            justify="center">
            {dataGraphics.map((x, i) => {
              return (
                <Grid item sm={3}>
                  <Paper style={{margin: 10, padding: 10}}>
                    <PieChartPending
                      key={i}
                      title={x.title}
                      data={x.data}
                      userName={x.value}
                      argumentField="title"
                      valueField="value"
                      group="test"
                      width={'50%'}
                      height={290}
                    />
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
          <Paper style={{margin: 10, padding: 10}}>
            <KPIGrid filters={filters} />
          </Paper>
        </>
      ) : null}
    </>
  );
};

export default ConsultForm;
